import { cva } from '@/styled-system/css';

export const upsellLegalRecipe = cva({
  base: {
    'marginBlockStart': 'tighter',

    '& > [data-c11n-component="Text"]': {
      color: 'inherit',
      textStyle: 'fineprint',
    },
    '& > [data-c11n-component="Paragraph"]': {
      color: 'inherit',
      textStyle: 'fineprint',
    },
  },
  variants: {
    tone: {
      neutral: {
        color: 'text.subtle',
      },
      soft: {
        color: 'text.subtle',
      },
      hero: {
        color: 'Upsell.Legal.hero.text-legal',
      },
      impact: {
        color: 'text.onImpact.neutral',
      },
    },
  },
});
